import { render, staticRenderFns } from "./loadTransferDetail.vue?vue&type=template&id=7c9ba65c&"
import script from "./loadTransferDetail.vue?vue&type=script&lang=js&"
export * from "./loadTransferDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports